import images from '@/assets/json/chair_colors';
import Utils from './Utils';

export default class PreloadImages {
  // 定義されている全ての画像をプリロードする
  static async loadImages() {
    let imageFiles = Utils.getImageFiles(images, true);
    // 床画像を追加
    imageFiles.unshift({ file: require(`@/assets/image/floor-canter.png`) });
    imageFiles.unshift({ file: require(`@/assets/image/floor.png`) });
    return await Promise.all(
      imageFiles.map(async (src) => {
        if (src.file) {
          await this.loadImage(src.file);
        } else {
          await src.parts.forEach((part) => this.loadImage(part.file));
        }
      })
    );
  }

  static loadImage(src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = (e) => reject(e);
      image.src = src;
    });
  }
}
